import { useTranslation } from 'react-i18next';

import { Badge } from '@saas-kit/ui';

import type { InvoiceStatus } from './api';

const VARIANT_BY_STATUS: Record<
  InvoiceStatus,
  'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline'
> = {
  draft: 'outline',
  issued: 'warning',
  paid: 'success',
  past_due: 'destructive',
  void: 'outline',
};

export function InvoiceStatusBadge({
  status,
}: {
  status: InvoiceStatus;
}): JSX.Element {
  const { t } = useTranslation('adminBilling');
  return <Badge variant={VARIANT_BY_STATUS[status]}>{t(`status.${status}`)}</Badge>;
}
